import { Routes, Route } from "react-router-dom";
import FormularioPage from "../pages/FormularioPage/FormularioPage";
import DescargaTomosPage from "../pages/DescargaTomosPage/DescargaTomosPage";
import DetalleMarcadas from "../pages/buscadorPublicacionesPage/detalleMarcadas/detalleMarcadas";
import VisorPdf from "../pages/buscadorPublicacionesPage/visorPdf/visorPdf";
import SuscripcionCancelada from "../pages/buscadorPublicacionesPage/suscripcionCancelada/suscripcionCancelada";
import SuscripcionCanceladaError from "../pages/buscadorPublicacionesPage/suscripcionCancelada/suscripcionCanceladaError";
import {Link } from "react-router-dom";

function NotFound() {
  return (
    <>
      <h1>Página no encontrada</h1>
      <Link to="/">Volver al inicio</Link>
    </>
  );
}

const AppRoutes = ({
  activeTab,
  setActiveTab,
  activeInnerTab,
  setActiveInnerTab
}) => {
  return (
    <Routes>

      {/* ✅ RUTA PRINCIPAL */}
      <Route
        path="/"
        element={
          <DescargaTomosPage
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            activeInnerTab={activeInnerTab}
            setActiveInnerTab={setActiveInnerTab}
          />
        }
      />

      <Route
        path="/descarga"
        element={
          <DescargaTomosPage
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            activeInnerTab={activeInnerTab}
            setActiveInnerTab={setActiveInnerTab}
          />
        }
      />

      <Route
        path="/buscador"
        element={
          <DescargaTomosPage
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            activeInnerTab={activeInnerTab}
            setActiveInnerTab={setActiveInnerTab}
          />
        }
      />

      {/* ✅ RUTA ALTERNATIVA */}
      <Route
        path="/bopiweb"
        element={
          <DescargaTomosPage
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            activeInnerTab={activeInnerTab}
            setActiveInnerTab={setActiveInnerTab}
          />
        }
      />

      {/* ✅ RESTO */}
      <Route
        path="/subscripcion-boletin"
        element={<FormularioPage />}
      />

      <Route
        path="/detalleMarcadas"
        element={<DetalleMarcadas />}
      />

      <Route
        path="/visorPdf"
        element={<VisorPdf />}
      />

      <Route
        path="/suscripcionCancelada"
        element={<SuscripcionCancelada />}
      />

      <Route
        path="/suscripcionCanceladaError"
        element={<SuscripcionCanceladaError />}
      />

      <Route 
        path="*" 
        element={<NotFound />} 
      />

    </Routes>
  );
};

export default AppRoutes;